const utilsConstants = {
    MIN_TIMELIMIT: 7,
}

export default utilsConstants;